import { IonButtons, IonCheckbox, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, useIonLoading, useIonModal } from '@ionic/react';
import React, { useState, useEffect, useRef } from 'react';
import { IonGrid, IonRow, IonCol } from '@ionic/react';
import { personCircle, eye, eyeOff, options, fingerPrint, logInOutline } from "ionicons/icons";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useParams } from "react-router";
import { IonItem, IonLabel, IonInput, IonButton, IonIcon, IonAlert } from '@ionic/react';
import axiosCall from '../data/axios';
import { Preferences } from '@capacitor/preferences';
import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
import { NativeBiometric } from "capacitor-native-biometric";

import AuthContext from "../UserContext";
import { getCaptchaToken } from "../Helper";

import UserStatus from "../components/UserStatus";
import { set } from 'date-fns';

function validateEmail(email: string) {
	const re = /^((?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\]))$/;
	return re.test(String(email).toLowerCase());
}

type AuthProps = {
	embedded?: boolean;
	afterLoginExecution?: (nextAuthValues: any) => void;
};

const Auth: React.FC<AuthProps> = ({ embedded = false, afterLoginExecution }) => {
	const history = useHistory();
	const location = useLocation<any>();
	const [email, setEmail] = useState<string>("");
	const [phone, setPhone] = useState<string>("");
	const [password, setPassword] = useState<string>("");
	const [re_password, setRePassword] = useState<string>("");
	const [name, setName] = useState<string>();
	const [iserror, setIserror] = useState<boolean>(false);
	const [message, setMessage] = useState<string>("");
	const [mode, setMode] = useState<string>(window.location.pathname);
	const { code }: any = useParams();
	const [tNcAgreeRef, setTNcAgreeRef] = useState<boolean>(false);
	const [bmEmail, setBmEmail] = useState<any>();
	const [triggerLogin, setTriggerLogin] = useState<boolean>(false);
	const didPostAuthRedirect = useRef(false);

	const { authValues, updateUser, fetchUser, logout } = React.useContext(AuthContext);

	const spinnerOptions = {
		message: 'Please wait...',
		animated: true,
		cssClass: 'drukre-loading',
		showBackdrop: true
	};

	const [spinnerPresent, spinnerDismiss] = useIonLoading();

	/*
	if (mode.indexOf('/chanel') > -1) {

		if (code) {

			const veriData = {
				"code": code
			}

			//spinnerPresent(spinnerOptions);

			axiosCall("/api/verifyEmailPhone", 'post', veriData)
				.then((res: any) => {
					//spinnerDismiss();
					//history.push("/login");
				})
				.catch((error: any) => {
					//setMessage("Unable to verify account. Please try again later.");
					//setIserror(true);
					//spinnerDismiss();
				});
		}
	}
	
	useEffect(() => {
		setMode(location.pathname);
	}, [location.pathname]);
	*/

	// This effect handles redirecting the user after authentication if they are on an auth page
	useEffect(() => {
		if (!authValues.authenticated) {
			didPostAuthRedirect.current = false;
			return;
		}

		const authPages = ['/login', '/register', '/resetpassword', '/verifyemail', '/chanel'];
		const isAuthPage = authPages.includes(mode);
		const isValidPostAuthRedirect = (path: any) => {
			if (typeof path !== 'string') {
				return false;
			}

			const trimmedPath = path.trim();
			if (!trimmedPath || !trimmedPath.startsWith('/')) {
				return false;
			}

			if (trimmedPath === '/') {
				return false;
			}

			return !authPages.some((authPage) => (
				trimmedPath === authPage ||
				trimmedPath.startsWith(`${authPage}/`) ||
				trimmedPath.startsWith(`${authPage}?`) ||
				trimmedPath.startsWith(`${authPage}#`)
			));
		};

		if (!isAuthPage) {
			didPostAuthRedirect.current = false;
			return;
		}

		if (didPostAuthRedirect.current) {
			return;
		}

		const redirectFromState = location.state?.from;
		const redirectFromStorage = sessionStorage.getItem('postAuthRedirect');
		const redirectPath = isValidPostAuthRedirect(redirectFromState)
			? redirectFromState
			: isValidPostAuthRedirect(redirectFromStorage)
				? redirectFromStorage
				: '/my-products';

		console.log(' --- Redirecting to:', redirectPath);

		sessionStorage.removeItem('postAuthRedirect');
		didPostAuthRedirect.current = true;

		history.replace(redirectPath);
	}, [authValues.authenticated, history, location.state, mode]);

	/*
	function clickMode(newMode: string) {

		//setMode(newMode);
		history.push(newMode);

	};

	
	function getCaptchaToken(action: any) {
		return new Promise((res, rej) => {
			grecaptcha.enterprise.ready(() => {
				grecaptcha.enterprise.execute('6Lf2DOopAAAAAKrW9hrL8_oxVXQrhxm3cYIbYrgd', {action: action}).then((token: any) => {
					return res(token);
				})
			})
		})
	}
	*/

	const [pushRegToken, setPushRegToken] = useState('');

	useEffect(() => {
		const registerPush = async () => {
			if (Capacitor.isNativePlatform()) {
				const pushTokenData = {
					"captchaToken": null,
					"captchaAction": '',
					"device_fcm_token": pushRegToken
				}
				await getCaptchaToken('SIGNUP').then((token: any) => { // Here wait token generated
					if (token) {
						pushTokenData.captchaToken = token;
						pushTokenData.captchaAction = 'SIGNUP';
					}
				});
				await PushNotifications.addListener('registration', token => {
					console.log('Push registration success, token: ' + token.value);
					setPushRegToken(token.value);
					
					pushTokenData.device_fcm_token = token.value;
					axiosCall("/api/saveDeviceToken", 'post', pushTokenData, true)
						.then((res: any) => {
							console.log("Device token saved");
						})
						.catch((error: any) => {
							console.error("Device token save failed: " + error.message);
						});
				});

				await PushNotifications.addListener('registrationError', error => {
					console.error('Push registration error: ', error);
					throw error;
				});

				let permStatus = await PushNotifications.checkPermissions();

				if (permStatus.receive === 'prompt') {
					permStatus = await PushNotifications.requestPermissions();
				}

				if (permStatus.receive !== 'granted') {
					throw new Error('User denied permissions!');
				}

				await PushNotifications.register();
			}
		};

		registerPush();
	}, []);

	if (Capacitor.isNativePlatform()) {
		Preferences.get({ key: 'userEmail' }).then((emailData) => {
			if (emailData.value != null)
				setBmEmail(emailData.value);
		});
	}

	const handleBiometricAuth = async () => {
		try {
			console.log('BiometricAuth.isAvailable called');
			const bmIsAvailable = await NativeBiometric.isAvailable();
			if(!bmIsAvailable.isAvailable){
				console.log('BiometricAuth.isAvailable not available');
				setMessage('Biometric authentication not available on your device');
				setIserror(true);
				return
			}
			//const isFaceID = bmIsAvailable.biometryType == BiometryType.FACE_ID;
			console.log('BiometricAuth.verify called');
			const result = await NativeBiometric.verifyIdentity({
				reason: "For easy log in",
				title: "Log In",
				subtitle: "Biometric Authentication",
				description: "Facial or Fingerprint Authentication",
			})
			.then(() => true)
			.catch(() => false);

			if (result) {
				console.log('BiometricAuth.verify result:', result);
				if (bmEmail != null)
					setEmail(bmEmail);
				let userPassword = Preferences.get({ key: 'userPassword' });
				// Await the promise resolution
				let userPasswordData = await userPassword;
				if (userPasswordData.value != null)
					setPassword(userPasswordData.value);
				// Trigger login after setting email and password
                setTriggerLogin(true);
			} else {
				console.log('BiometricAuth.verify failed');
				setMessage('Authentication failed!');
				setIserror(true);
			}
		} catch (error: any) {
			setMessage('Error during authentication: ' + error.message);
			setIserror(true);
		}
	};

	useEffect(() => {
        if (triggerLogin && email && password) {
            handleLogin();
            setTriggerLogin(false); // Reset the trigger
        }
    }, [triggerLogin]);

	const handleLogin = async (passwordOverride?: string) => {
		const effectivePassword = passwordOverride ?? password;

		if (!email) {
			setMessage("Please enter a valid email");
			setIserror(true);
			return;
		}
		if (validateEmail(email) === false) {
			setMessage("Your email is invalid");
			setIserror(true);
			return;
		}

		if (!effectivePassword || effectivePassword.length < 6) {
			setMessage("Please enter your password");
			setIserror(true);
			return;
		}

		const loginData = {
			"email": email,
			"password": effectivePassword,
			"captchaToken": null,
			"captchaAction": '',
			"device_fcm_token": pushRegToken
		}

		spinnerPresent(spinnerOptions);

		/*await grecaptcha.enterprise.ready(async () => {
		  const captchaToken = await grecaptcha.enterprise.execute('6Lf2DOopAAAAAKrW9hrL8_oxVXQrhxm3cYIbYrgd', {action: "LOGIN"});
		  loginData.captchaToken = captchaToken;
		});*/

		await getCaptchaToken('LOGIN').then((token: any) => { // Here wait token generated
			if (token) {
				loginData.captchaToken = token;
				loginData.captchaAction = 'LOGIN';
			}
		}).catch((error: any) => {
			setMessage("Login captcha failed, please retry: " + error.message);
			setIserror(true);
			spinnerDismiss();
			return;
		});

		axiosCall("/api/login", 'post', loginData, false, 'application/json')
			.then(async (res: any) => {
				Preferences.set({
					key: 'accessToken',
					value: res.data.access_token,
				});
				if (Capacitor.isNativePlatform()) {
					Preferences.set({
						key: 'userEmail',
						value: email
					});
					Preferences.set({
						key: 'userPassword',
						value: effectivePassword
					});
				}

				const userRes = await axiosCall("/api/user", "get", null, true);
				const nextAuthValues = {
					authenticated: true,
					user: userRes,
					isLoading: false
				};

				if (afterLoginExecution) {
					afterLoginExecution(nextAuthValues);
				} else {
					await updateUser(nextAuthValues);
				}
				spinnerDismiss();
			})
			.catch((error: any) => {
				setMessage("Failed to authenticate! " + error.message);
				setIserror(true);
				spinnerDismiss();
			});
	};

	const LoginOtpModal = ( {dismiss, otpResponse}: any ) => {

		let isNew = false;
		if(otpResponse?.userIsNew) {
			isNew = true;
		}

		const [otpCode, setOtpCode] = useState<string>("");
		const [openAdminPasswordAlert, setOpenAdminPasswordAlert] = useState<boolean>(false);
		const [showPassword, setShowPassword] = useState(false);
		const [adminPassword, setAdminPassword] = useState<string>("");

		const processOTPLogin = async () => {

			if (!otpCode || otpCode.length < 4) {
				setMessage("Please enter the OTP sent to your email");
				setIserror(true);
				return;
			}

			const filter = {
				email: email,
				code: otpCode,
				captchaToken: '',
				captchaAction: 'LOGIN'
			};

			spinnerPresent(spinnerOptions);

			await getCaptchaToken('LOGIN').then((token: any) => { // Here wait token generated
				if (token) {
					filter.captchaToken = token;
					filter.captchaAction = 'LOGIN';
				}
			}).catch((error: any) => {
				setMessage("Login captcha failed, please retry: " + error.message);
				setIserror(true);
				spinnerDismiss();
				return;
			});

			await axiosCall("/api/loginotp", 'post', filter, true)
				.then((res) => {
					setIserror(false);
					//An interface to add password
					let tempPassword = res.data.tempPassword;
					if(res.data.isAdmin) {
						setOpenAdminPasswordAlert(true);
						return;
					}
					dismiss({tempPassword: tempPassword}, 'confirm');
				})
				.catch((error: any) => {
					setMessage("Failed to verify OTP! " + error.message);
					setIserror(true);
				}).finally(() => {
					spinnerDismiss();
				});
		};
		
		return (
			<IonContent className="ion-padding ion-text-center">
				<IonRow>
					<IonCol>
						<IonLabel color="danger">{message}</IonLabel>
					</IonCol>
				</IonRow>
				<IonRow>
					<IonCol>
						<IonIcon
							color="drukre"
							style={{ fontSize: "70px" }}
							icon={personCircle}
						/>
					</IonCol>
				</IonRow>
				{openAdminPasswordAlert && (
					<>
						<IonRow>
							<IonCol>
								<h2>Admin Login Detected</h2>
							</IonCol>
						</IonRow>
						<IonRow>
							<IonCol>
								<IonItem className='ion-padding'>
									<IonInput
										labelPlacement='floating'
										label="Password"
										type={showPassword ? 'text' : 'password'}
										fill="outline"
										placeholder="Enter your password"
										value={adminPassword}
										onIonInput={(e) => setAdminPassword(e.detail.value!)}
										className="ion-padding"
									/>
									<IonButton fill="clear" slot="end" onClick={() => setShowPassword(!showPassword)}>
										<IonIcon icon={showPassword ? eyeOff : eye} />
									</IonButton>
								</IonItem>
							</IonCol>
						</IonRow>
						<IonRow>
							<IonCol>
								<IonButton expand="block" color="drukre" onClick={() => dismiss({ tempPassword: adminPassword }, 'confirm')}>
									Proceed
								</IonButton>
							</IonCol>
						</IonRow>
					</>
				)}
				{isNew ? (
					<IonRow>
						<IonCol>
							<IonLabel color="danger">It looks like this is your first time logging in with that email. Would you like to continue?</IonLabel>
						</IonCol>
					</IonRow>
				) : null}
				{!openAdminPasswordAlert && (
					<>
						<IonRow>
							<IonCol>
								<p>OTP has been sent to your email. Please enter the OTP to login.</p>
								<IonInput labelPlacement='floating' label="OTP Code" type="text" 
									fill="outline" placeholder="Enter OTP here"
									value={otpCode} onIonInput={(e) => setOtpCode(e.detail.value!)}>
								</IonInput>
							</IonCol>
						</IonRow>
						<IonItem>
							<IonToolbar>
								<IonButtons slot="start">
									<IonButton color="medium" onClick={() => {
										dismiss(null, 'cancel');
									}}>Cancel</IonButton>
								</IonButtons>
								<IonButtons slot="end">
									<IonButton color="drukre" onClick={() => {
										processOTPLogin();
									}}>Submit</IonButton>
								</IonButtons>
							</IonToolbar>
						</IonItem>
					</>
				)}
			</IonContent>
		);
	};

	const [otpResponseData, setOtpResponseData] = useState<any>(null);
	const [ presentOTP, setPresentOTP ] = useIonModal(LoginOtpModal, {
		dismiss: (data: any, role: string) => setPresentOTP(data, role),
		backdropDismiss: false,
		otpResponse: otpResponseData
	});

	const requestOTPLogin = async () => {

		if(!email) {
			setMessage("Please enter a valid email");
			setIserror(true);
			return;
		}
		if(validateEmail(email) === false) {
			setMessage("Your email is invalid");
			setIserror(true);
			return;
		}

		spinnerPresent(spinnerOptions);

		const filter = {
			email: email,
			captchaToken: null,
			captchaAction: 'LOGIN'
		};

		await getCaptchaToken('OTP_LOGIN').then((token: any) => { // Here wait token generated
			if (token) {
				filter.captchaToken = token;
			}
		});
		
		await axiosCall("/api/loginotp", 'post', filter, true)
			.then((res) => {
				setIserror(false);
				setOtpResponseData(res.data);
				presentOTP({
                    initialBreakpoint: 0.5,
                    breakpoints: [0.35, 0.5, 0.7, 1],
                    backdropBreakpoint: 0,
                    backdropDismiss: false,
                    onWillDismiss: (ev) => {
                        if (ev.detail.role === 'confirm') {
                            afterOTP(ev.detail);
                        }
                    }
                });
			})
			.catch((error: any) => {
				setMessage("Failed to send OTP! " + error.message);
				setIserror(true);
			}).finally(() => {
				spinnerDismiss();
			});

	};

	function afterOTP(data: any) {
		const tempPassword = data?.data?.tempPassword ?? data?.tempPassword ?? null;
		if (tempPassword) {
			setPassword(tempPassword);
			handleLogin(tempPassword);
		} else {
			setMessage("OTP verification failed. Please try logging in again.");
			setIserror(true);
		}
	}

	const handlePasswordReset = async () => {

		if (!email) {
			setMessage("Please enter a valid email");
			setIserror(true);
			return;
		}

		if (validateEmail(email) === false) {
			setMessage("Your email is invalid");
			setIserror(true);
			return;
		}
		const resetData = {
			"email": email,
			"captchaToken": null,
			"captchaAction": ''
		}

		await getCaptchaToken('RESET').then((token: any) => { // Here wait token generated
			if (token) {
				resetData.captchaToken = token;
				resetData.captchaAction = 'RESET';
			}
		});

		spinnerPresent(spinnerOptions);

		const headers = {
			'Content-Type': 'application/json'
		}

		axiosCall("/api/resetPassword", 'post', resetData, true)
			.then((res: any) => {
				spinnerDismiss();
				setMessage("Password Reset Email sent. Please check your email.");
			})
			.catch((error: any) => {
				setMessage("Reset request failed. " + error.message);
				setIserror(true);
				spinnerDismiss();
			});
	};

	const handleVerification = () => {

		if (!password || password.length < 6) {
			setMessage("Please enter your password");
			setIserror(true);
			return;
		}

		if (password != re_password) {
			return;
		}

		const regData = {
			"password": password,
			"re_password": password,
			"code": code
		}

		spinnerPresent(spinnerOptions);

		const headers = {
			'Content-Type': 'application/json'
		}

		axiosCall("/api/verifyEmail", 'post', regData, true)
			.then((res: any) => {
				spinnerDismiss();
				setMessage("Password successfully set. You can now login.");
				setMode('/login')
				history.push("/login");
			})
			.catch((error: any) => {
				setMessage("Unable to verify account. " + error.message);
				setIserror(true);
				spinnerDismiss();
			});

	};

	/*
	const handleRegistration = async () => {

		if (!email) {
			setMessage("Please enter a valid email");
			setIserror(true);
			return;
		}
		if (validateEmail(email) === false) {
			setMessage("Your email is invalid");
			setIserror(true);
			return;
		}
		if (!phone) {
			setMessage("Please enter a valid phone");
			setIserror(true);
			return;
		}
		if (!tNcAgreeRef) {
			setMessage("Please agree to our terms and conditions by clicking the check box.");
			setIserror(true);
			return;
		}

		const regData = {
			"name": name,
			"email": email,
			"phone": phone,
			"captchaToken": null,
			"captchaAction": '',
			"device_fcm_token": pushRegToken
		}

		spinnerPresent(spinnerOptions);

		const headers = {
			'Content-Type': 'application/json'
		}

		await getCaptchaToken('SIGNUP').then((token: any) => { // Here wait token generated
			if (token) {
				regData.captchaToken = token;
				regData.captchaAction = 'SIGNUP';
			}
		});

		axiosCall("/api/register", 'post', regData, true)
			.then((res: any) => {
				spinnerDismiss();
				setMode("/login");
				history.push("/login");
				setMessage("Please check your email for a link. ");
			})
			.catch((error: any) => {
				setMessage(error.message);
				setIserror(true);
				spinnerDismiss();
			});

	};

	const [showPassword, setShowPassword] = useState(false);
	*/
	const authContent = (
		<IonGrid>
			<IonRow>
			{window.location.pathname == '/resetpassword' ?
				<IonCol size-md="6" offset-md="3">
					<IonRow>
						<IonCol>
							<IonLabel color="danger">{message}</IonLabel>
						</IonCol>
					</IonRow>
					<IonRow>
						<IonCol>
							<IonIcon
								color="drukre"
								style={{ fontSize: "70px" }}
								icon={personCircle}
							/>
						</IonCol>
					</IonRow>
					<IonRow>
						<IonCol>
							<IonItem>
								<IonLabel position="stacked"> Email</IonLabel>
								<IonInput type="email" value={email} onIonChange={(e) => setEmail(e.detail.value!)}>
								</IonInput>
							</IonItem>
						</IonCol>
					</IonRow>
					<IonRow>
						<IonCol>
							<IonButton color="drukre" expand="block" onClick={handlePasswordReset}>Reset Password</IonButton>
						</IonCol>
					</IonRow>
					<IonRow>
						<IonCol>
							<p style={{ fontSize: "medium" }}>
								Go to <a onClick={() => history.push('/login')}>Sign In!</a>
							</p>
						</IonCol>
					</IonRow>
				</IonCol>
			: window.location.pathname.indexOf('/verifyemail') > -1 ?
				<IonCol size-md="6" offset-md="3">
					<IonRow>
						<IonCol>
							<IonLabel color="danger">{message}</IonLabel>
						</IonCol>
					</IonRow>
					<IonRow>
						<IonCol>
							<IonIcon
								color="drukre"
								style={{ fontSize: "70px" }}
								icon={personCircle}
							/>
						</IonCol>
					</IonRow>

					<IonRow>
						<IonCol>
							<IonItem>
								<IonLabel position="stacked"> Password</IonLabel>
								<IonInput type="password" onIonChange={(e) => setPassword(e.detail.value!)} >
								</IonInput>
							</IonItem>
						</IonCol>
					</IonRow>

					<IonRow>
						<IonCol>
							<IonItem>
								<IonLabel position="stacked"> Re Enter Password</IonLabel>
								<IonInput type="password" onIonChange={(e) => setRePassword(e.detail.value!)} >
								</IonInput>
								{re_password != password && <p style={{ fontSize: "small", color: "red", textAlign: "center" }}>Passwords did not match!</p>}
							</IonItem>
						</IonCol>
					</IonRow>

					<IonRow>
						<IonCol>
							<p style={{ fontSize: "small" }}>
								By clicking REGISTER you agree to our <span onClick={() => history.push("/terms-and-conditions")}>Terms and Conditions</span>
							</p>
							<IonButton color="drukre" expand="block" onClick={handleVerification}>Verify</IonButton>
							<p style={{ fontSize: "medium" }}>
								Already have an account? <a onClick={() => history.push('/login')}>Sign In!</a>
							</p>

						</IonCol>
					</IonRow>
				</IonCol>
			: !authValues.authenticated ?
				<IonCol size-md="6" offset-md="3">
					<IonRow>
						<IonCol>
							<IonLabel color="danger">{message}</IonLabel>
						</IonCol>
					</IonRow>
					<IonRow>
						<IonCol>
							<IonIcon
								color="drukre"
								style={{ fontSize: "70px" }}
								icon={personCircle}
							/>
						</IonCol>
					</IonRow>
					<IonRow>
						<IonCol>
							<IonInput labelPlacement='floating' label="Email" type="email" 
								fill="outline" placeholder="Enter your email" className="ion-text-left"
								value={email} onIonInput={(e) => setEmail(e.detail.value!)}>
							</IonInput>
						</IonCol>
					</IonRow>
					<IonRow>
						<IonCol>
							<IonButton color="drukre" onClick={requestOTPLogin}> <IonIcon icon={logInOutline} className="ion-padding-end"></IonIcon>Login </IonButton>
							<p style={{ fontSize: "small" }}>
								By clicking LOGIN you agree to our <span onClick={() => history.push("/terms-and-conditions")}>Terms and Conditions</span>
							</p>
						</IonCol>
					</IonRow>
					{Capacitor.isNativePlatform() && bmEmail != null &&
						<IonRow>
							<IonCol>
								<IonButton color="drukre" onClick={handleBiometricAuth}><IonIcon icon={fingerPrint}></IonIcon>{bmEmail}</IonButton>
							</IonCol>
						</IonRow>
					}
				</IonCol>
				:
				<IonCol size-md="6" offset-md="3">
					<UserStatus />
				</IonCol>
			}
			</IonRow>
			<IonRow>
				<IonCol>
					<p style={{ fontSize: "small" }}>
						This site is protected by reCAPTCHA and the Google
						<a href="https://policies.google.com/privacy" target="_blank"> Privacy Policy</a> and
						<a href="https://policies.google.com/terms" target="_blank"> Terms of Service</a> apply.
					</p>
				</IonCol>
			</IonRow>
		</IonGrid>
	);

	if (embedded) {
		return (
			<div className="ion-padding ion-text-center page-content">
				{authContent}
			</div>
		);
	}

	return (
		<IonPage>
			<IonHeader>
				<IonToolbar>
					<IonTitle>Login</IonTitle>
				</IonToolbar>
			</IonHeader>
			<IonContent className="ion-padding ion-text-center page-content">
				{authContent}
			</IonContent>
		</IonPage>
	);
};

export default Auth;